import { useNavigate, useParams } from '@remix-run/react'
import { type Option, Select } from '#app/components/ui/select.tsx'
import { formatDate } from '#app/utils/date.ts'

type Variation = {
	id: string
	createdAt: string
	description: string | null
}

export function VariationsSelect(props: { variations: Variation[] }) {
	const params = useParams()
	const navigate = useNavigate()
	const value = params.variationId || 'original'

	let options: Option[] = props.variations.map(variation => ({
		value: variation.id,
		label: (
			<span className="flex w-full flex-row items-center justify-between gap-2">
				{variation.description}{' '}
				<span className="text-xs text-foreground/40">
					{formatDate(variation.createdAt)}
				</span>
			</span>
		),
	}))
	options.unshift({ value: 'original', label: 'Version original' })

	return (
		<Select
			className="w-64"
			popoverClassName="w-64"
			options={options}
			value={value}
			onChange={version => {
				let baseUrl = `/plantillas/${params.category}/${params.slug}`
				if (version === 'original' || version === '') {
					navigate(baseUrl)
				} else {
					navigate(`${baseUrl}/variation/${version}`)
				}
			}}
			label="Selecciona otra version"
			emptyMessage="No hay mas versiones"
		/>
	)
}
